import React from "react"
import { useLocalStorage } from "../../hooks/use-local-storage"

type ReportingMethod = "single-day" | "multiple-days"

type UseReportingMethodOptions = {
  fromDate: Date
  toDate: Date
  setDateRange: (dateRange: { fromDate: Date; toDate: Date }) => void
}

const REPORTING_METHOD_LOCAL_STORAGE_KEY = "starbrix_hour_reporting_method"

const isSameDay = (fromDate: Date, toDate: Date) => fromDate.toDateString() === toDate.toDateString()

export const useReportingMethod = ({ fromDate, toDate, setDateRange }: UseReportingMethodOptions) => {
  const initialMethod = isSameDay(fromDate, toDate) ? "single-day" : "multiple-days"
  const [reportingMethod, setStoredReportingMethod] = useLocalStorage<ReportingMethod>(
    REPORTING_METHOD_LOCAL_STORAGE_KEY,
    initialMethod
  )
  const isSingleDay = reportingMethod === "single-day"

  React.useEffect(() => {
    if (!isSingleDay || isSameDay(fromDate, toDate)) return

    setDateRange({ fromDate, toDate: fromDate })
  }, [fromDate, isSingleDay, setDateRange, toDate])

  const setReportingMethod = (nextReportingMethod: ReportingMethod) => {
    if (nextReportingMethod === reportingMethod) return

    if (nextReportingMethod === "single-day") {
      const now = new Date()
      setDateRange({ fromDate: now, toDate: now })
    }

    setStoredReportingMethod(nextReportingMethod)
  }

  return { isSingleDay, setReportingMethod }
}
